import Slice from "@/onboarding/features/product/Slice"
import Product from "@/onboarding/features/product/Product"
import { withApp } from "@/components/App"

export default withApp(Product, { slices: [Slice] })
